import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import RandomDescriptions from './components/RandomDescriptions';
export default function addHomeDescriptions() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    // IndexSidebar is shared between the homepage ('/') and tag pages
    // ('/t/:tags', see flarum-tags' own route - both use IndexPage) - this
    // widget is homepage-only, matching champis.net/home's own layout, so
    // it's skipped whenever a `tags` route param is present.
    if (m.route.param('tags')) return;

    // Below core's 'newDiscussion' item (default priority 0, see
    // IndexSidebar.tsx) - 'nav' used to fill this slot but champis-forum's
    // removeSidebarNav.js dropped it, leaving this the first thing under
    // the button, matching champis.net/home's own layout.
    items.add('champis-random-descriptions', m(RandomDescriptions, null), -10);
  });
}